import React from 'react';
import './Sections.scss';

function SectionContent({ section }) {
  // const videoLoopRef = useRef();

  // useEffect(() => {
  //   videoLoopRef.current.play();
  // }, [videoLoopRef]);

  return (
    <>
      {section.backgroundType === 'video' ? (
        <section className={`section section--${section.content}`} id={section.id}>
          <div className="section-overlay" />
          <div className="section-videoloop">
            <video autoPlay muted playsInline loop className="videoloop">
              <source media="(min-width:481px)" src={section.backgroundVid} type="video/mp4" />{' '}
              <source media="(max-width:480px)" src={section.backgroundVidM} type="video/mp4" />
              Your browser does not support HTML5 video.
            </video>
          </div>
          <div className="section__content">
            <p className="section__content__title">{section.title}</p>
            <p className="section__content__copy">{section.copy}</p>
            <a
              id={section.content}
              className="section__content__button"
              href={section.url}
              target="_blank"
              rel="sponsored"
            >
              <button className={`button button-${section.content}`}>{section.button}</button>
            </a>
            {section.button2 && (
              <a
                id={section.content}
                className="section__content__button"
                href={section.url2}
                target="_blank"
                rel="sponsored"
              >
                <button className={`button button-${section.content}`}>{section.button2}</button>
              </a>
            )}
          </div>
        </section>
      ) : (
        <section className={`section section--${section.content}`} id={section.id}>
          <div className="section-overlay" />
          <div className="section-videoloop"></div>
          <div className="section__content">
            <p className="section__content__title">{section.title}</p>
            <p className="section__content__copy">{section.copy}</p>
            <a
              id={section.content}
              className="section__content__button"
              href={section.url}
              target="_blank"
              rel="sponsored"
            >
              <button className={`button button-${section.content}`}>{section.button}</button>
            </a>
            {section.button2 && (
              <a
                id={section.content}
                className="section__content__button"
                href={section.url2}
                target="_blank"
                rel="sponsored"
              >
                <button className={`button button-${section.content}`}>{section.button2}</button>
              </a>
            )}
          </div>
        </section>
      )}
    </>
  );
}

export default SectionContent;
